import { Package, Policy, Puzzle, Stack } from "components/icons/generated";
import { IconComponent } from "types/Icon";

const restoreSubListItemData = (
  path: string
): {
  icon: IconComponent | undefined;
  title: string;
} => {
  if (path.startsWith("/stack/")) return { icon: Stack, title: "Stack" };
  if (path.startsWith("/module/")) return { icon: Package, title: "Module" };
  if (path.startsWith("/policy/")) return { icon: Policy, title: "Policy" };
  if (path.startsWith("/context/")) return { icon: Puzzle, title: "Context" };

  return { icon: undefined, title: "" };
};

export default restoreSubListItemData;
